export { default as ConfirmationPasswordForm } from './ConfirmationPasswordForm';
